import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchReports({ payload }) {
  try {
    const res = yield call(API.fetchAllOrderReportsList, payload);
    const { data } = res;
    yield put(actions.fetchReportsSuccess(data));
  } catch (err) {
    yield put(actions.fetchReportsFailure(err?.response?.data));
  }
}

export function* handleAllCommodities() {
  try {
    const res = yield call(API.fetchAllCommodities);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* reviewReportsSaga() {
  yield takeLatest(actions.fetchReports.type, handleFetchReports);
  yield takeLatest(actions.fetchCommodities.type, handleAllCommodities);
}
